import SearchButton from "components/common/SearchButton/SearchButton";

const Actions = () => {
  return <div className="d-flex gap-2">{<SearchButton />}</div>;
};

export default Actions;
